import { Box } from '@mui/material';
import { format } from 'date-fns';

import { cx } from '@/styles/muiTheme';

type Props = {
  /** ISO string, Date, or epoch milliseconds — whatever the caller's API returns. */
  value: string | number | Date | null | undefined;
  /** Rendered when there is no value. */
  fallback?: string;
};

/**
 * Two-line timestamp for a table cell: date above, time below, smaller and
 * muted. Splitting them lets the date column scan vertically instead of every
 * row being one long run of text.
 *
 * The design called for the time in Sohne Mono, but the app only ships
 * sohne-buch and sohne-kraftig, so the hierarchy is carried by size and color
 * rather than a fallback monospace that would read as off-brand next to Sohne.
 */
const DateTimeCell = ({ value, fallback = 'N/A' }: Props) => {
  if (!value) return <>{fallback}</>;

  const date = new Date(value);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3 }}>
      <Box component="span">{format(date, 'MMM d, yyyy')}</Box>
      <Box component="span" sx={{ fontSize: 11, color: cx.text.muted }}>
        {format(date, 'h:mm a')}
      </Box>
    </Box>
  );
};

export default DateTimeCell;
